import DtoMaterielAssignment from './DtoMaterielAssignment'
import DtoTelecom from './DtoTelecom'

export default class DtoStationTelecomAssignment extends DtoMaterielAssignment {
    constructor(obj) {
        super(obj)
        this.id = obj.idTelecomSituation
        this.idTelecomSituation = obj.idTelecomSituation
        this.idTelecom = obj.idTelecom
        this.materielId = obj.idTelecom
        this.materiel = obj.materiel && new DtoTelecom(obj.materiel)
    }
}